export default __webpack_public_path__ + "static/media/Group 10496.5040adf5.png";